import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('memberApplicationStates', app)
  return store
}
